import { render, staticRenderFns } from "./KingscupGame.vue?vue&type=template&id=5957d9ac&"
import script from "./KingscupGame.vue?vue&type=script&lang=js&"
export * from "./KingscupGame.vue?vue&type=script&lang=js&"
import style0 from "./KingscupGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports